const SunMoonMain: React.FC = () => <Outlet />;
export default SunMoonMain;
